import React, { useState, useEffect } from 'react';
import './Counter.css';

const Counter = ({ title, initialValue, stopValue, imageSrc }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (count + initialValue < stopValue) {
        setCount((prevCount) => prevCount + 1);
      }
    }, 100); // Ajustez l'intervalle au besoin

    // Efface l'intervalle lors du démontage du composant
    return () => clearInterval(interval);
  }, [count, initialValue, stopValue]);

  return (
    <div className="counter">
      <div className="counter-content">
        <img src={imageSrc} alt={`Icon for ${title}`} className="counter-image" />
        <div className="counter-text">
        <div className="counter-value"><span><span>{count + initialValue} </span> <span className="counter-title"> {title}</span></span>
        </div>        
        </div>
      </div>
    </div>
  );
};

export default Counter;



